import { Dispatch } from '@/context/types';
import { FormDeepKeys } from '@/types';

export const useSetFormValue =
  (dispatch: React.Dispatch<Dispatch>) =>
  (field: FormDeepKeys, value: any): void => {
    dispatch({ action: 'risk_update_field', payload: { field, value } });
  };
